export const environment = {
  production: true,
  authServer: 'https://gw.arketipo.riatlas.net/authorization',
  resourceServer: 'https://gw.arketipo.riatlas.net/resource',
  fhirServer: 'https://gw.arketipo.riatlas.net/fhir',
  elastic: 'https://gw.arketipo.riatlas.net/resource',
  mobile: 'https://gw.arketipo.riatlas.net/mobile',
  company: 'Riatlas.it',
  baseHref: 'cloud'
};
